import enUS from './en-US'
import esMX from './es-MX'

export default {
  'en-US': enUS,
  'es-MX': esMX
}
